export const ENV = {
    NODE_ENV: process.env.NODE_ENV,
    PUBLIC_URL: process.env.PUBLIC_URL,
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    ENABLE_ADDITIONAL_ASSISTS: process.env.REACT_APP_ENABLE_ADDITIONAL_ASSISTS === "1",
    ZOHO: {
        enabled: process.env.REACT_APP_ZOHO_ENABLED === "1",
        ECOMMERCE_NAME: process.env.REACT_APP_ZOHO_ECOMMERCE_NAME,
    },
    NAVIGATION: {
        HAS_BROWSER_ROUTER: Number(process.env.REACT_APP_HAS_BROWSER_ROUTER) === 1,
    },
    GTM_CODE: process.env.REACT_APP_GTM_CODE,
    QUOTE: {
        MAX_SECONDS: Number(process.env.REACT_APP_QUOTE_MAX_SECONDS) * 1000,
        INTERVAL_SECONDS: Number(process.env.REACT_APP_QUOTE_INTERVAL_SECONDS) * 1000,
        VALIDATE_DOCUMENT_NUMBER_ENABLED: JSON.parse(
            process.env.REACT_APP_VALIDATE_DOCUMENT_NUMBER_ENABLED || "false"
        ),
    },
    RECAPTCHA: {
        PUBLIC_KEY: process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY,
        DEFAULT_ACTION: process.env.REACT_APP_RECAPTCHA_DEFAULT_ACTION,
    },
    SECURITY: {
        EXPONENT: Number(process.env.REACT_APP_SECURITY_CRYPT_EXPONENT),
        MODULUS: String(process.env.REACT_APP_SECURITY_CRYPT_MODULUS),
    },
    PRICES: {
        MONTHLY_MIN_PRIME_PRICE: Number(process.env.REACT_APP_MONTHLY_MIN_PRIME_PRICE),
        HOUSING_INSURANCE_PRICE_TIER_1: Number(
            process.env.REACT_APP_HOUSING_INSURANCE_PRICE_TIER_1
        ),
        HOUSING_INSURANCE_PRICE_TIER_2: Number(
            process.env.REACT_APP_HOUSING_INSURANCE_PRICE_TIER_2
        ),
        ASSETS_INSURANCE_PRICE_TIER_1: Number(
            process.env.REACT_APP_ASSETS_INSURANCE_PRICE_TIER_1
        ),
    },
    LANDING: {
        VIDEO_ID: process.env.REACT_APP_LANDING_VIDEO_ID,
        VENDORS_DELAY: Number(process.env.REACT_APP_VENDORS_DELAY || "5000"),
        CALCULATOR_RESTRICTED: JSON.parse(
            process.env.REACT_APP_LANDING_CALCULATOR_RESTRICTED || "true"
        ),
    },
    PAYMENT: {
        MAX_SECONDS: Number(process.env.REACT_APP_PAYMENT_MAX_SECONDS) * 1000,
        INTERVAL_SECONDS: Number(process.env.REACT_APP_PAYMENT_INTERVAL_SECONDS) * 1000,
    },
    ID_TOKEN: process.env.REACT_APP_ID_TOKEN,
    URL_TOKEN: process.env.REACT_APP_URL_TOKEN,
    SUBSCRIPTION_KEY: process.env.REACT_APP_SUBSCRIPTION_KEY,
    API_MANAGEMENT_URL: process.env.REACT_APP_API_URL,
    SHOW_PERSONAL_DATA_CONSENT_AT_PAYMENT_PAGE:
        process.env.REACT_APP_SHOW_PERSONAL_DATA_CONSENT_AT_PAYMENT_PAGE || true,
    MINIMUM_SUM_THINGS_INSURED: process.env.REACT_APP_MINIMUM_SUM_THINGS_INSURED,
    MINIMUM_QUOTE_THINGS_INSURED: process.env.REACT_APP_MINIMUM_QUOTE_THINGS_INSURED,
    REACT_APP_IS_A_FORM: process.env.REACT_APP_IS_A_FORM,
};
